export default __webpack_public_path__ + "static/media/20160305-p4.6f9874dd.pdf";